import { AccountType } from "../../utils/constants";

export const accountNameRenderer = (record) => {
  const account = record?.account ?? record;
  const accountName =
    account?.displayName || account?.businessName || record?.accountName || "";
  const internalAccountName =
    record?.accountName || account?.displayName || account?.businessName || "";

  if (account?.accountType === AccountType.INTERNAL) {
    if (account.id === record.billToAccountId) {
      return `${accountName} \u2003 \u{FF20}`;
    } else {
      return `${internalAccountName} \u2003 \u{FF20}`;
    }
  }
  if (account?.accountType === AccountType.BROKERED) {
    return `${accountName} \u2003 \u{21C4}`;
  }

  return accountName;
};
